/* The live a2ui catalog (vendored from BeX-3DApps-Engine/catalogs/v1.json) +
 * the end-user grouping used by the Components playground. Single source of
 * truth for which components exist + their props/closed-sets/required flags. */
import catalogJson from "./catalog.v1.json";
import type { Catalog, CatalogComponentDef } from "../preview/engine/types";

export const CATALOG = catalogJson as unknown as Catalog;

export interface Group {
  id: string;
  label: string;
  blurb: string;
  members: string[];
}

export const GROUPS: Group[] = [
  { id: "layout", label: "Layout & Containers", blurb: "Arrange other components on the screen.",
    members: ["Row", "Column", "List", "Card", "Tabs", "Modal", "Divider"] },
  { id: "text", label: "Text & Media", blurb: "Show content to the user.",
    members: ["Text", "Image", "Icon", "Video", "AudioPlayer"] },
  { id: "inputs", label: "Inputs & Actions", blurb: "Collect input and trigger actions.",
    members: ["TextField", "CheckBox", "DateTimeInput", "MultipleChoice", "Slider", "FileUpload", "Turnstile", "Button", "Form"] },
  { id: "data", label: "Data", blurb: "Display structured records.",
    members: ["DataTable"] },
  { id: "status", label: "Status & Feedback", blurb: "Progress, state and alerts.",
    members: ["Stepper", "ProgressIndicator", "StatusBadge", "Notification"] },
  { id: "people", label: "People", blurb: "Represent a person.",
    members: ["Avatar"] },
];

export function defForType(type: string): CatalogComponentDef | undefined {
  return CATALOG.components[type];
}

/** Every component type, in group order. */
export const ALL_TYPES: string[] = GROUPS.flatMap((g) => g.members);
